// extracted by mini-css-extract-plugin
export default {"title":"AddressesHeader_title__oAtP5","logo_wrapper":"AddressesHeader_logo_wrapper__n9nCc","logo":"AddressesHeader_logo__neqG2"};